import React from "react";

const SvgBBiconsStahnout = props => (
  <svg viewBox="0 0 200 200" {...props}>
    <path
      d="M100 26.82A73.18 73.18 0 10173.18 100 73.18 73.18 0 00100 26.82zM101.2 52a3.72 3.72 0 013.72 3.72v55l14.51-14.5a3.67 3.67 0 012.62-1.08 3.72 3.72 0 012.65 6.35L104 122.25c-.06.06-.08.15-.14.22a3.74 3.74 0 01-5.27 0L77.7 101.62a3.74 3.74 0 010-5.27 3.78 3.78 0 012.65-1.08A3.71 3.71 0 0183 96.35l14.51 14.48V55.75A3.72 3.72 0 01101.2 52zm-42.7 50.09a3.72 3.72 0 013.72 3.72v27.32h78v-27.32a3.73 3.73 0 017.45 0v27.9a6.64 6.64 0 01-6.42 6.86h-80a6.64 6.64 0 01-6.42-6.86v-27.9a3.72 3.72 0 013.67-3.72z"
      data-name="Obecn\xE9 ikony"
    />
  </svg>
);

export default SvgBBiconsStahnout;

